import FontAwesomeIconContainer from "../../Components/Icons/FontAwesomeIcon/FontAwesomeIcon"

const FontAwesomeIcon = () => {
  return (
    <div className='page-body'>
      <FontAwesomeIconContainer />
    </div>
  )
}

export default FontAwesomeIcon